<template>
  <div class="container-fluid">
    <div class="loading" v-if="isLoading">Loading&#8230;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Reglas de promociones</h1>
          <p class="view-header__subtitle">Definí precios especiales por producto según cantidad vendida.</p>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- TABLA -->
      <div class="col-md-8">
        <div class="data-table">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Unidad</th>
                  <th>Desde</th>
                  <th>Hasta</th>
                  <th>Precio</th>
                  <th class="text-right">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="rule in rules" :key="rule.id">
                  <td><span class="data-table__primary">{{ rule.producto }}</span></td>
                  <td class="data-table__muted">{{ rule.unidad }}</td>
                  <td>{{ rule.fromqty }}</td>
                  <td>{{ rule.toqty }}</td>
                  <td>{{ rule.price }}</td>
                  <td class="text-right">
                    <div class="table-action-group">
                      <button class="table-action-btn" type="button" title="Editar" @click="editRule(rule)">
                        <i class="bi bi-pencil"></i>
                      </button>
                      <button class="table-action-btn" type="button" title="Eliminar" @click="removeRule(rule)">
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="rules.length === 0">
                  <td colspan="6" class="data-table__empty">No hay reglas cargadas</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- FORMULARIO -->
      <div class="col-md-4">
        <NewRule
          :ruleId="ruleId"
          :products="products"
          :priceLists="priceLists"
          @saved="onSaved"
          @reset-id="ruleId = null"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NewRule from '../../sub-components/New-rule.vue';

export default {
  components: { NewRule },
  data() {
    return {
      isLoading: false,
      ruleId: null,
      rules: [],
      products: [],
      priceLists: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      this.$http
        .get('/api/configs/promo/getData', {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
        .then((response) => {
          const payload = response.data.data || response.data || {};
          this.rules = payload.rules || [];
          this.products = payload.products || [];
          this.priceLists = payload.pricelists || payload.priceLists || [];
          this.isLoading = false;
        })
        .catch(() => { this.isLoading = false; });
    },
    editRule(rule) {
      this.ruleId = rule.id;
    },
    removeRule(rule) {
      if (confirm("¿Está seguro que desea borrar esta regla?") !== true) return;
      this.isLoading = true;
      this.$http
        .post(`/api/configs/rule/delete/${rule.id}`)
        .then((response) => {
          if (response.data.code == 200) this.loadData();
          else this.isLoading = false;
        })
        .catch(() => { this.isLoading = false; });
    },
    onSaved() {
      this.ruleId = null;
      this.loadData();
    },
  },
};
</script>